export default class User {
  auth!: string;
  email!: string;
  username!: string;
  pipedriveId!: number;
  admin!: boolean;
}
